import { useState } from "react";
import "./FaqPage.css";
import blankImg from "../assets/images/questionBlankImg.png";
import cargoImg from "../assets/images/questionDeliveryImg.png";
import letterImg from "../assets/images/questionCardImg.png";
import giftBox from "../assets/images/questionBoxImg.png";
import SEO from "../components/SEO";
import questionBanerImg from "../assets/images/questionBanerImg.png"
const CATEGORIES = [
  { id: "order", image: blankImg, label: "Замовлення" },
  { id: "payment", image: letterImg, label: "Оплата" },
  { id: "delivery", image: cargoImg, label: "Доставка" },
  { id: "products", image: giftBox, label: "Товари" },
];

const FAQS = [
  {
    cat: "products",
    q: "Що таке декоративна наліпка?",
    a: `Декоративна наліпка — це інтер’єрний декор у вигляді зображення із самоклеючої плівки, де кожен елемент точно вирізаний по контуру. Завдяки цьому вона виглядає охайно та створює ефект малюнка, нанесеного безпосередньо на стіну.
Виготовляються наліпки з якісної матової вінілової плівки преміум-класу німецького виробництва: вона довговічна, не вигорає на сонці, стійка до вологи та підходить для вологого прибирання. Усі елементи наклеюються окремо, без білих контурів, що дозволяє самостійно створювати композицію та адаптувати її під власний простір і настрій.
Наліпки призначені для одноразового використання, але під час монтажу їх можна відклеювати й переклеювати, обираючи ідеальне розташування. Це простий і швидкий спосіб оновити інтер’єр без ремонту, додаючи йому стилю, затишку та індивідуальності.`,
  },
  {
    cat: "products",
    q: "Поверхні для поклейки",
    a: `Наліпки добре тримаються на рівних, гладких і стабільних поверхнях. Це можуть бути: пофарбовані стіни (тестування поверхні обов’язкове), шпалери вінілові/флізелінові, меблі, скло, пластик, ламіновані поверхні, оброблене дерево.
 Перед поклейкою важливо, щоб поверхня була сухою, чистою, без пилу та жиру. Обов’язково перед поклейкою — протерти її сухою або злегка вологою тканиною і дати висохнути.`,
  },
  {
    cat: "products",
    q: "На що не можна клеїти наліпки?",
    a: `Наліпки не будуть добре триматися або можуть відклеюватися з часом, якщо поклеїти їх на:
рельєфні або шорсткі стіни (декоративна штукатурка, грубі шпалери)
поверхні, що осипаються або фарба відходить
свіжопофарбовані / свіжопоклеєні стіни (менше 2–3 тижнів після фарбування/поклейки)
вологі або жирні поверхні
стіни з силіконовими або водовідштовхувальними покриттями, напиленням блисківок`,
  },
  {
    cat: "products",
    q: "Тестування поверхні",
    a: `Щоб уникнути проблем після поклейки, рекомендуємо зробити простий тест:
 наклейте шматочок малярного або звичайного скотчу на поверхню та залиште на 24 години.
 Якщо скотч:
добре тримається
легко знімається
не тягне за собою фарбу або покриття
— така поверхня підходить для наліпок. Якщо ж скотч відпадає або пошкоджує стіну — краще підготувати поверхню або утриматися від поклейки.`,
  },
  {
    cat: "products",
    q: "Наліпки багаторазові чи одноразові?",
    a: `Наші наліпки розраховані на одноразове нанесення.
Однак під час монтажу їх можна акуратно відклеювати та коригувати розташування до досягнення потрібного результату. 
В залежності від поверхні:
клейкий шар може частково втратити властивості
можливе деформування елементів
Тому для ідеального результату рекомендуємо одразу клеїти в правильне місце`,
  },
  {
    cat: "order",
    q: "Індивідуальне замовлення",
    a: `Ми можемо виготовити будь-який декор за індивідуальним замовленням: постери, наліпки, фотошпалери, зростоміри та дерев’яний декор.
Адаптуємо дизайн під ваші розміри, підбираємо кольори під інтер’єр, змінюємо елементи або створюємо повністю унікальний макет з нуля. Перед виготовленням обов’язково надаємо макет для погодження, щоб ви були впевнені в результаті.`,
  },
  {
    cat: "products",
    q: "Як використовувати монтажну плівку?",
    a: `Монтажна плівка використовується для перенесення наліпок (особливо написів або складних елементів):
Наклейте плівку поверх наліпки та добре розгладьте
Зніміть підкладку — наліпка залишиться на плівці
Прикладіть до поверхні та вирівняйте
Розгладьте від центру до країв
Повільно зніміть плівку під кутом
Це дозволяє точно розмістити всі елементи без зміщення.`,
  },
  {
    cat: "products",
    q: "Як клеїти на скло/пластик/дзеркало?",
    a: `Для ідеального результату на гладких поверхнях рекомендуємо мокрий метод поклейки:
розпиліть воду (можна додати 1–2 краплі мила) з пульверизатора на поверхню
прикладіть наліпку — вона не приклеїться одразу, і ви зможете її рухати
виставіть правильне положення
виженіть воду та повітря ракелем або пластиковою карткою
дайте висохнути
Такий спосіб допомагає уникнути бульбашок, перекосів і складок.`,
  },
  {
    cat: "products",
    q: "Як клеїти наліпки/шпалери?",
    a: `Разом із кожним замовленням ми додаємо детальну покрокову інструкцію, адаптовану під тип продукції.
 У ній описано:
підготовку поверхні
процес поклейки
рекомендації по інструментах
Дотримуючись інструкції, більшість клієнтів легко справляються самостійно. При бажанні можна скористатися послугами майстра.`,
  },
  {
    cat: "products",
    q: "Чи можна подивитись, як це буде виглядати?",
    a: `Так, щоб ви були впевнені у виборі, ми надаємо безкоштовну візуалізацію:
для фотошпалер — накладаємо дизайн на фото вашої кімнати
для наліпок — робимо примірку розміру та розташування на стіні
Це допомагає оцінити масштаб, кольори та загальний вигляд ще до замовлення.`,
  },
  {
    cat: "products",
    q: "Від чого залежить ціна шпалер?",
    a: `Ціна вказується за квадратний метр (м²).
 Фінальна вартість залежить від:
розмірів вашої стіни
текстури матеріалу
Ми завжди робимо індивідуальний прорахунок перед підтвердженням замовлення.`,
  },
  {
    cat: "products",
    q: "На чому друкуються шпалери?",
    a: `Ми друкуємо на флізелінових шпалерах різних текстур:
гладкі
з легкою фактурою
більш виражені декоративні варіанти
Флізелін — це міцний, екологічний матеріал, який не розтягується, не рветься та зручний у поклейці.`,
  },
  {
    cat: "products",
    q: "Чи складно клеїти шпалери? Чи можна їх мити?",
    a: `Поклейка досить проста:
клей наноситься на стіну, а не на шпалери
полотна стикуються впритул без нахльосту
кожне полотно підганяється по малюнку
Разом з продукцією ми вкладаємо детальну інструкцію, за допомогою якої монтаж буде ще простішим. Проте за бажанням можна скористатись послугами майстра.
Шпалери мають захисне покриття, тому їх можна акуратно протирати вологою тканиною без агресивних засобів.`,
  },
  {
    cat: "products",
    q: "Як правильно заміряти стіну для шпалер?",
    a: `Потрібно виміряти повну ширину та висоту стіни:
у кількох точках (оскільки стіни можуть бути нерівними)
брати найбільші значення
До вказаних параметрів ми додаємо 5-10 см запасу по периметру, щоб під час монтажу можна було ідеально підрізати краї.`,
  },
  {
    cat: "order",
    q: "Чи можливе повернення шпалер/наліпок?",
    a: `Фотошпалери виготовляються за індивідуальними параметрами (розміри, дизайн), тому повернення або обмін не передбачені. У разі виробничого браку або помилки з нашого боку — ми безкоштовно здійснюємо передрук.
Наліпки можна повернути або обміняти протягом 14 днів згідно законодавства, за умови збереження товарного вигляду (не були використані, не пошкоджені, збережена упаковка).
 Зверніть увагу: наліпки, виготовлені за індивідуальним замовленням (зміна розміру, кольору або макету), поверненню та обміну не підлягають`,
  },
  {
    cat: "order",
    q: "Чи є співпраця?",
    a: `Так, ми відкриті до співпраці та пропонуємо вигідні оптові умови для партнерів.
Працюємо за системою дропшипінгу, що дозволяє продавати нашу продукцію без власного складу.
Також розглядаємо співпрацю з UGC-креаторами на бартерній основі.
Для дизайнерів інтер’єру та декораторів діють партнерські знижки.
З радістю обговоримо деталі та підберемо зручний формат співпраці.`,
  },
];

function FaqItem({ item }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={"faq-item" + (open ? " open" : "")}>
      <button className="faq-question" onClick={() => setOpen(!open)}>
        <span>{item.q}</span>
        <span className={"faq-chevron" + (open ? " open" : "")}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="faq-answer">
          <p>{item.a}</p>
        </div>
      )}
    </div>
  );
}

export default function FaqPage() {
  const [activeCat, setActiveCat] = useState("");

  const filtered = activeCat ? FAQS.filter((f) => f.cat === activeCat) : FAQS;

  return (
    <div className="faq-page page-enter">
      <SEO
        title="Питання/відповідь"
        description="Питання/відповідь про замовлення, оплату, доставку та товари"
        url="https://zori.place/faq"
      />
      {/* Hero */}
      <section className="faq-hero">
	 <img src={questionBanerImg} alt="Question baner" fetchpriority="high" decoding="async" className="hero-bg" />
        <div className="container">
          <div className="faq-hero-inner">
            <div className="faq-hero-content">
              <h1 className="faq-hero-title">Питання/відповідь</h1>
              <p className="faq-hero-desc">
                Відповіді на найпоширеніші запитання про замовлення, оплату, доставку та товари
              </p>
              <div className="faq-category-icons">
                {CATEGORIES.map((c) => (
                  <button
                    key={c.id}
                    className={
                      "faq-cat-icon" + (activeCat === c.id ? " active" : "") + " cat-" + c.id
                    }
                    onClick={() => setActiveCat(activeCat === c.id ? "" : c.id)}
                  >
                    <img src={c.image} alt="icon"></img>
                    <span>{c.label}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ List */}
      <section className="faq-section">
        <div className="container">
          <div className="faq-list">
            {filtered.map((item, i) => (
              <FaqItem key={i} item={item} />
            ))}
          </div>

          <div className="faq-cta">
            <p>Не знайшли відповідь?</p>
            <a href="/contact" className="btn-primary">
              Написати нам
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
